/*
 * @Author: JamesWong
 * @Description: 应用版本英文包
 * @Date: 2018-11-29 15:14:04
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-29 16:01:48
 */
export default {
  appVersion: 'Application Version',
  backstageVersion: 'Backstage Version',
  enabledIOSVersion: 'Enabled IOS',
  enabledAndroidVersion: 'Enabled Android',
  enabledPadVersion: 'Enabled Android Pad',
  versionUpdateDesc: 'Version Update Description',
  downloadQRcode: 'Download QR code',
  downloadAddress: 'Download Address',
  downloadArticle: 'Download Iteration Advertisement',
  '版本详情': 'Version Detail',
  Close: 'close',
  '点击详情': 'Click Details',
  '未启用': 'Not Enabled',
  '可联系商务开通': 'Can Contact Business to Open',
  '下载链接': 'Download link',
  '下载': 'download'
}


// WEBPACK FOOTER //
// ./src/i18n/en/appversion.js